export const fieldTypes = {
  title: 2,
  descriptionText: 3,
  smallTextField: 0,
  bigTextField: 1,
  datePicker: 4,
  dropdown: 5,
  conclusionTitle: 6,
  conclusionText: 7,
};
